import Vue from 'vue'

const observerContext = '@@observerContext'

Vue.directive('observer', {
    bind(el, binding) {
        const observerOptions = {
            rootMargin: '-85% 0% -10% 0%',
            threshold: 0,
        }

        // A target stays observed: the callback runs only when it enters the band, and a loaded
        // placeholder loses its data-page, so a page whose fetch failed is requested again the
        // next time it is scrolled into view, without a request loop (tasks#134).
        function observerCallback(entries) {
            entries.forEach(({ isIntersecting, target }) => {
                if (isIntersecting && target.dataset.page) {
                    binding.value(target.dataset.page)
                }
            })
        }
        const observer = new IntersectionObserver(observerCallback, observerOptions)
        el.children.forEach((child) => {
            if (child.dataset.page) {
                observer.observe(child)
            }
        })
        el[observerContext] = {
            observer,
        }
    },

    componentUpdated(el) {
        const { observer } = el[observerContext]
        let disconnect = true
        el.children.forEach((child) => {
            if (child.dataset.page) {
                observer.observe(child)
                if (disconnect) disconnect = false
            }
        })
        if (disconnect) {
            try {
                observer.disconnect()
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn(e)
            }
        }
    },

    unbind(el) {
        const { observer } = el[observerContext]
        try {
            observer.disconnect()
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn(e)
        }
    },
})
